import * as Storage from '@aws-amplify/storage';
import { KeyboardEvent } from "react";
import { Editor, Node, Text, Transforms } from "slate";
import { errorMessage } from "../../../../shared/consts";
import { logger } from "../../../../shared/utils";
import { isSelectionEjs } from "../helpers";
import { StandardElement } from "../types";

export const getEjsTemplateFromS3 = async (
  templateName: string,
  bucket = "happy-legal-templates"
): Promise<string> => {
  // In Amplify v6, use downloadData() instead of Storage.get()
  // downloadData returns a task object with a .result property that is a Promise
  // The API uses 'path' instead of 'key' for the file identifier
  try {
    const { body } = await Storage.downloadData({
      path: templateName,
      options: {
        bucket,
      },
    }).result;

    const template = await body.text();
    return typeof template === "string" ? template : "";
  } catch (err) {
    const message = `Error retrieving ${templateName} template from ${bucket} S3 bucket.`;
    logger(message, err);
    // Return an empty string so the caller never receives undefined. Callers
    // (Newsletter.tsx, EjsLinkButtonButton.tsx) already check for empty
    // templates and skip rendering, so a missing template surfaces as a blank
    // preview rather than a fake fallback that hides the S3 outage.
    return "";
  }
};

export const handleBreakoutEjsBlocks = (
  event: KeyboardEvent<HTMLDivElement>,
  editor: Editor
) => {
  const selection = editor.selection;

  if (event.key !== "Enter" || !selection || isSelectionEjs(editor)) return;

  event.preventDefault();

  const selectedLeaf = Node.descendant(editor, selection.anchor.path);

  const isSelectedLeafText =
    Text.isText(selectedLeaf) &&
    selectedLeaf.text.length === selection.anchor.offset;

  if (isSelectedLeafText) {
    const paragraphElement: StandardElement = {
      type: "paragraph",
      children: [{ text: "" }],
    };

    Transforms.insertNodes(editor, paragraphElement);
  } else {
    Transforms.splitNodes(editor);
    Transforms.setNodes(editor, { type: "paragraph" });
  }
};

export * from './hotkeys';
